import CitySEOHead from "@/components/feature/CitySEOHead";
import PanamaCityHeroSection from "./components/HeroSection";
import PanamaCityStickyNav from "./components/StickyNav";
import PanamaCityProcessingTimeSection from "./components/ProcessingTimeSection";
import PanamaCityServicesSection from "./components/ServicesSection";
import PanamaCityLocalAreaSection, { landmarks as panamacityLandmarks } from "./components/LocalAreaSection";
import PanamaCityTestimonialsSection from "./components/TestimonialsSection";
import PanamaCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PanamaCityComparisonSection from "./components/ComparisonSection";
import PanamaCityMistakesSection from "./components/MistakesSection";
import PanamaCityHowItWorksSection from "./components/HowItWorksSection";
import PanamaCityFAQSection, { faqs } from "./components/FAQSection";
import PanamaCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PanamaCityFinalCTA from "./components/FinalCTA";
import PanamaCityTravelTimingSection from "./components/TravelTimingSection";
import PanamaCityDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Panama City, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Panama City, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Florida Panhandle and Emerald Coast.";

const areaServedList = [
  { "@type": "City", name: "Panama City" },
  { "@type": "City", name: "Panama City Beach" },
  { "@type": "City", name: "Lynn Haven" },
  { "@type": "City", name: "Callaway" },
  { "@type": "City", name: "Mexico Beach" },
  { "@type": "City", name: "Rosemary Beach" },
  { "@type": "City", name: "Port St. Joe" },
  { "@type": "AdministrativeArea", name: "Bay County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Panama City, Panama City Beach, Lynn Haven, and Bay County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function PanamaCityPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Panama City"
        state="Florida"
        stateAbbr="FL"
        route="/cities/panama-city"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Panama City, Florida"
        geoPosition="30.1588;-85.6602"
        keywords="expedited passport Panama City, emergency passport Panama City FL, same day passport Panama City, fast passport Florida Panhandle, passport renewal Panama City, Panama City passport courier"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={panamacityLandmarks}
      />
      <PanamaCityHeroSection />
      <PanamaCityStickyNav />
      <PanamaCityLocalAreaSection />
      <PanamaCityProcessingTimeSection />
      <PanamaCityServicesSection />
      <PanamaCityTravelTimingSection />
      <PanamaCityDestinationsSection />
      <PanamaCityTestimonialsSection />
      <PanamaCityAcceptanceFacilitiesSection />
      <PanamaCityComparisonSection />
      <PanamaCityMistakesSection />
      <PanamaCityHowItWorksSection />
      <PanamaCityFAQSection />
      <PanamaCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/panama-city" state="FL" />
      <PanamaCityFinalCTA />
    </div>
  );
}